const ratings = [
  {
    name: "Rahul",
    location: "Indore",
    title: "",
    description:
      "The best fitting jeans I’ve bought in years! The fabric is so sturdy yet soft.",
  },
  {
    name: "Priya",
    location: "Mumbai",
    title: "",
    description:
      "Finally, denim that understands Indian body types. Worth every rupee.",
  },
  {
    name: "Arjun",
    location: "Delhi",
    title: "",
    description:
      "I’ve worn my Capronik jeans for over a year—they still look brand new.",
  },
];

export { ratings };
